import dayjs from 'dayjs'
import { NewIcon } from '@/components/icon'
import { SummaryButton } from '@/components/summary'
import { SummaryDetail } from '@/types/summary'
import { Author, BookmarkButtons, Calligraphy } from '.'
import { UserInfo } from '@/types/user'
import { isErrorResponse } from '@/types/error'
import { isFacility } from '@/utils/user'

interface Props {
  userInfo: UserInfo
  summary: SummaryDetail
  bookmark: boolean
  favorite: boolean
}

export const HeaderSp: React.FC<Props> = ({
  userInfo,
  summary,
  bookmark,
  favorite,
}) => {
  const weekago = dayjs().subtract(8, 'd')
  return (
    <div className="px-[10px] mt-5 sp">
      <div className="w-full h-auto align-top">
        <div className="pb-[10px] leading-5 align-top">
          <div className="flex w-full">
            {dayjs(summary.released).isAfter(weekago) && (
              <div className="relative">
                <NewIcon className="absolute top-[-18px] left-[-10px] z-[1000] w-[50px] h-[50px] text-fl-yellow bg-white rounded-full" />
              </div>
            )}
            {/** 書影部分 */}
            <Calligraphy id={summary.id} title={summary.title} />
            <div className="flex-2">
              {summary.subpos == 1 && (
                <div className="text-sm">{summary.subtitle}</div>
              )}
              <div className="text-xl font-medium">{summary.title}</div>
              {summary.subpos == 2 && (
                <div className="text-sm">{summary.subtitle}</div>
              )}
              <div className="pt-5">
                <Author authors={summary.authors} showBorder={false} />
              </div>
            </div>
          </div>
          {/** あとで読むとか */}
          <div className="flex pb-5 mt-[10px] w-full border-b border-[#e6e6e6] border-solid">
            <div className="flex-1 align-top">
              <SummaryButton summary={summary} />
            </div>
            {!isErrorResponse(userInfo) && !isFacility(userInfo?.email) && (
              <div className="flex-1 align-top">
                <BookmarkButtons
                  key={summary.id}
                  summaryId={summary.id}
                  bookmark={bookmark}
                  favorite={favorite}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
